import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};
export const Progress50Icon = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 15.0001 15.0001"
        fill="none"
      >
        <g id="progress-50">
          <path
            id="Inner ellipse"
            d="M7.5 0.625105C11.297 0.625105 14.375 3.70315 14.375 7.5001C14.375 11.2971 11.297 14.3751 7.5 14.3751C3.70305 14.3751 0.625 11.2971 0.625 7.5001C0.625 3.70315 3.70305 0.625105 7.5 0.625105Z"
            stroke="#676979"
            strokeWidth="1.25002"
          />
          <g id="Union">
            <mask id="progress-50-mask" fill="white">
              <path d="M7.4999 2.18756C8.90887 2.18756 10.2604 2.74694 11.2567 3.74322C12.253 4.7395 12.8124 6.0911 12.8124 7.50006C12.8124 8.90902 12.253 10.2606 11.2567 11.2569C10.2604 12.2532 8.90888 12.8125 7.4999 12.8126V2.18756Z" />
            </mask>
            <path
              d="M7.4999 2.18756C8.90887 2.18756 10.2604 2.74694 11.2567 3.74322C12.253 4.7395 12.8124 6.0911 12.8124 7.50006C12.8124 8.90902 12.253 10.2606 11.2567 11.2569C10.2604 12.2532 8.90888 12.8125 7.4999 12.8126V2.18756Z"
              fill="#676979"
            />
            <path
              d="M7.4999 2.18756L7.49991 1.54362L6.85596 1.54361V2.18756H7.4999ZM11.2567 3.74322L11.7121 3.28789L11.7121 3.28788L11.2567 3.74322ZM12.8124 7.50006H13.4563V7.50005L12.8124 7.50006ZM11.2567 11.2569L11.7121 11.7122L11.7121 11.7122L11.2567 11.2569ZM7.4999 12.8126H6.85596V13.4565L7.49991 13.4565L7.4999 12.8126ZM7.4999 2.18756L7.4999 2.8315C8.73823 2.8315 9.92598 3.32314 10.8014 4.19856L11.2567 3.74322L11.7121 3.28788C10.5949 2.17074 9.07951 1.54362 7.49991 1.54362L7.4999 2.18756ZM11.2567 3.74322L10.8014 4.19855C11.6768 5.07397 12.1684 6.26173 12.1685 7.50007L12.8124 7.50006L13.4563 7.50005C13.4563 5.92047 12.8292 4.40504 11.7121 3.28789L11.2567 3.74322ZM12.8124 7.50006H12.1685C12.1685 8.73837 11.6768 9.92612 10.8014 10.8016L11.2567 11.2569L11.7121 11.7122C12.8292 10.5951 13.4563 9.07966 13.4563 7.50006H12.8124ZM11.2567 11.2569L10.8014 10.8016C9.92597 11.677 8.73824 12.1686 7.4999 12.1686L7.4999 12.8126L7.49991 13.4565C9.07952 13.4565 10.5949 12.8294 11.7121 11.7122L11.2567 11.2569ZM7.4999 12.8126H8.14384V2.18756H7.4999H6.85596V12.8126H7.4999Z"
              fill="#676979"
              mask="url(#progress-50-mask)"
            />
          </g>
        </g>
      </svg>
    </Center>
  );
};
